import React from "react";
import NavBar from "./NavBar";
import { NavLink } from "react-router";
import logo from "../assets/Images/imageLogo_bgRev.png";
import LogoWhatSapp from "../assets/icons/whatsapp-svgrepo-com.svg";
import { IoLogoTiktok } from "react-icons/io5";
import { FaFacebookF, FaYoutube } from "react-icons/fa";
import Contacts from "../views/frontOfficeView/Contacts";
import { LiaToolsSolid } from "react-icons/lia";

const Layout = ({ children }) => {
  const onSubmit = () => {
    const msg = "Hello je souhaite avoir plus d'information sur un produit";
    const phoneWithCountryCode = "+1234567890"; // Ensure the phone number includes the country code
    if (msg) {
      const url = `https://wa.me/${"+2250564021616"}?text=${encodeURIComponent(
        msg
      )}`;
      window.open(url, "_blank");
    } else {
      alert("Please insert message to send");
    }
  };

  return (
    <div className="min-h-screen flex flex-col relative bg-gray-50   ">
      {/* Barre de nativation fixed */}
      <div className="sticky top-0 z-30">
        <NavBar />
      </div>

      {/* Contenu */}

      {/* Menus flottant */}
      <div className=" xl:hidden lg:hidden  flex flex-row items-center justify-center fixed left-5 right-5  bottom-[-5px] transform -translate-y-1/2 z-50">
        <ul className="border-2 flex flex-row justify-center items-center w-fit gap-4  px-4 py-1.5 bg-[#dbd5d5] rounded-lg">
          <button
            className="lg:tooltip bg-gray-200 px-2 py-2 rounded-lg hover:bg-[#3dbe329f]"
            data-tip="Acceuil"
          >
            <a href="/">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
            </a>
          </button>
          <button
            className="bg-gray-200 px-2 py-2 rounded-lg hover:bg-[#3dbe329f] lg:tooltip "
            data-tip="A propos"
          >
            <NavLink to="/apropos">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </NavLink>
          </button>

          <button
            onClick={onSubmit}
            className="bg-gray-200 px-2 py-2 rounded-lg hover:bg-[#3dbe329f] lg:tooltip "
            data-tip="Nous joindre"
          >
            <img src={LogoWhatSapp} className="w-5 h-5" alt="" />
          </button>

          <div className="dropdown dropdown-top dropdown-end">
            <button
              className="bg-gray-200 px-2 py-2 rounded-lg hover:bg-[#3dbe329f] lg:tooltip "
              data-tip="Nos services"
              tabIndex={0}
            >
              <LiaToolsSolid className="w-5 h-5" />
            </button>
            <ul
              tabIndex={0}
              className="dropdown-content menu bg-base-100 rounded-box z-1 w-52 p-2 shadow-sm"
            >
              <NavLink
                to={"/service-installation"}
                className="font-medium text-[16px] hover:bg-primary hover:text-white py-2 px-2 hover:font-semibold rounded-md"
              >
                Service installation
              </NavLink>
              <NavLink
                to={"/service-technique"}
                className="font-medium text-[16px] hover:bg-primary hover:text-white py-2 px-2 hover:font-semibold rounded-md"
              >
                Service technique
              </NavLink>
              <NavLink
                to={"/service-maintenance"}
                className="font-medium text-[16px] hover:bg-primary hover:text-white py-2 px-2 hover:font-semibold rounded-md"
              >
                Service réparation
              </NavLink>
            </ul>
          </div>
        </ul>
      </div>

      <div className="flex flex-col items-center justify-center w-full ">
        {children}
      </div>

      <Contacts />

      {/* Pied de page */}
      <footer className="  ">
        <div className="px-4 pt-16 w-full  md:px-24 lg:px-8  border-t-[1px] border-gray-200">
          <div className="grid gap-10 row-gap-6 mb-8 sm:grid-cols-2 lg:grid-cols-4">
            <div className="sm:col-span-2 relative">
              <NavLink to={"/"} className="text-lg font-semibold italic">
                <img src={logo} alt="" className="w-[140px]" />
              </NavLink>
              {/* <div className="mt-6 lg:max-w-sm">
                <p className="text-sm text-gray-800">
                  Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                  accusantium doloremque laudantium, totam rem aperiam.
                </p>
                <p className="mt-4 text-sm text-gray-800">
                  Eaque ipsa quae ab illo inventore veritatis et quasi
                  architecto beatae vitae dicta sunt explicabo.
                </p>
              </div> */}
            </div>
            <div className="space-y-2 text-sm">
              <p className="text-base font-bold tracking-wide text-gray-900">
                Contacts
              </p>
              <div className="flex">
                <p className="mr-1 text-gray-800">Phone:</p>
                <div className="flex flex-row gap-x-2 justify-start items-start gap-y-1">
                  <a
                    href="tel:+2250564021616"
                    aria-label="Our phone"
                    title="Our phone"
                    className="transition-colors duration-300 text-deep-purple-accent-400 hover:text-deep-purple-800"
                  >
                    +2250564021616
                  </a>
                  {";"}
                  <a
                    href="tel:+2252522008055"
                    aria-label="Our phone"
                    title="Our phone"
                    className="transition-colors duration-300 text-deep-purple-accent-400 hover:text-deep-purple-800"
                  >
                    +2252522008055
                  </a>
                </div>
              </div>
              <div className="flex">
                <p className="mr-1 text-gray-800">Email:</p>
                <a
                  href="mailto:infos@godleadershop.ci"
                  aria-label="Our email"
                  title="Our email"
                  className="transition-colors duration-300 text-deep-purple-accent-400 hover:text-deep-purple-800"
                >
                  infos@godleadershop.ci
                </a>
              </div>
              <div className="flex">
                <p className="mr-1 text-gray-800">Adresses:</p>
                <a
                  href="/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Our address"
                  title="Our address"
                  className="transition-colors duration-300 text-deep-purple-accent-400 hover:text-deep-purple-800"
                >
                  <span>Abobo Samanké</span> <br />
                  <span>Non loin de la pharmacie kennedy</span>
                </a>
              </div>
            </div>
            <div>
              <span className="text-base font-bold tracking-wide text-gray-900">
                Social
              </span>

              <p className="mt-4 text-sm text-gray-500">
                Vous pouvez également nous suivre à travers nos Réseaux sociaux

              </p>
              <div className="flex items-center mt-4 space-x-3">
                <a
                  href="https://www.tiktok.com/@godleadershop?_t=ZM-8wVyyocGJDc&_r=1"
                  target="_blank"
                  rel="noreferrer"
                  className="bg-gray-200 p-2 rounded-lg transition-colors duration-300 hover:text-deep-purple-accent-400"
                >
                  <IoLogoTiktok />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=100064164725003"
                  target="_blank"
                  rel="noreferrer"
                  className="bg-gray-200 p-2 rounded-lg transition-colors duration-300 hover:text-deep-purple-accent-400"
                >
                  <FaFacebookF />

                </a>

                <a
                  href="https://youtube.com/@godleadershop225?si=ueSrcTjpnYreavk5"
                  target="_blank"
                  rel="noreferrer"
                  className="bg-gray-200 p-2 rounded-lg transition-colors duration-300 hover:text-deep-purple-accent-400"
                >
                  <FaYoutube />

                </a>


              </div>
            </div>
          </div>
          <div className="flex flex-col-reverse justify-between pt-5 pb-10 border-t lg:flex-row">
            <p className="text-sm text-gray-600">
              © Copyright {new Date().getFullYear()} GodLeaderShop. All rights reserved.
            </p>

            <ul className="flex flex-col mb-3 space-y-2 lg:mb-0 sm:space-y-0 sm:space-x-5 sm:flex-row">
              <li>
                <a
                  href="/"
                  className="text-sm text-gray-600 transition-colors duration-300 hover:text-deep-purple-accent-400"
                >
                  F.A.Q
                </a>
              </li>
              <li>
                <a
                  href="/"
                  className="text-sm text-gray-600 transition-colors duration-300 hover:text-deep-purple-accent-400"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/"
                  className="text-sm text-gray-600 transition-colors duration-300 hover:text-deep-purple-accent-400"
                >
                  Terms &amp; Conditions
                </a>
              </li>
              <li>
                <a
                  href="/"
                  className="text-sm text-gray-600 transition-colors duration-300 hover:text-deep-purple-accent-400"
                >
                  Politique de confidentialité
                </a>
              </li>
              <li>
                <a
                  href="/"
                  className="text-sm text-gray-600 transition-colors duration-300 hover:text-deep-purple-accent-400"
                >
                  by <span className="text-gray-800  font-semibold">welf@Code</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
};


export default Layout;
